import React from 'react'
import { TitleSection } from '../../../title-section'
import { FeatureBox } from './feature-box'

export default function FeatureSection() {
  return (
    <section id="services" className="services">
      <div className="container">
        <TitleSection title="Features" description="State of the art features" />

        <div className="row">
          <FeatureBox
            icon="bi bi-box2-heart"
            title="Modern technology, platform and design"
            description="Available for modern platform such as laptop, tablets, phone and even TV as long you use modern browser."
          />
          <FeatureBox
            icon="bi bi-card-checklist"
            title="Customizable Reports"
            description="Our PIVOTS based reporting tools provide customized reports in minutes and not hours. Save any custom PIVOT template and re-use it at your will!"
          />
          <FeatureBox
            icon="bi bi-bar-chart"
            title="Integrated Database"
            description="Plants, Labs, FSA Offices, and Haulers, all this information at your fingertips, no manual updating required at all."
          />
          <FeatureBox
            icon="bi bi-binoculars"
            title="On-Line Support System"
            description="Support ticket entry, tracking, a complete Total Milk knowledge base library and videos, remote assistance on desktop and mobile platforms."
          />
          <FeatureBox
            icon="bi bi-brightness-high"
            title="On-Time, Instant, Online!"
            description="No need to remind the plants for the test results, once available users can get it online immidiately."
          />
          <FeatureBox
            icon="bi bi-calendar4-week"
            title="Access anywhere!"
            description="Access the full producer payment information anywhere as long you are connected to internet."
          />
        </div>
      </div>
    </section>
  )
}
